import { render } from "./AddMindMoviePost.vue?vue&type=template&id=2718d5b5&scoped=true"
import script from "./AddMindMoviePost.vue?vue&type=script&lang=js"
export * from "./AddMindMoviePost.vue?vue&type=script&lang=js"

import "./AddMindMoviePost.vue?vue&type=style&index=0&id=2718d5b5&scoped=true&lang=scss"

import exportComponent from "/Users/johnahnz0rs/0-PROJECTS/stackin-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2718d5b5"]])

export default __exports__